const keys = {
  payload: "transaction_payload",
  set_packs: "set_packs",
};

export default keys;
